function setupReadMore($desc) {
  if ($desc.length && !$desc.hasClass("processed")) {
    $desc.addClass('processed')
    if ($('p', $desc).height() > 49) {
        $('p', $desc).addClass("show-line-2");
        const $button = $('<span class="read-more-toggle cursor-pointer fw-bold d-block text-center">Read More</span>');
        $desc.after($button);
        $button.on("click", function () {
          $desc.toggleClass("expanded");
          $('p', $desc).toggleClass("show-line-2");
          $(this).text($desc.hasClass("expanded") ? "Read Less" : "Read More");
        });
    }

  }
}

// Run once in case element is already in DOM
$(document).ready(function () {
  setupReadMore($(".boost-sd__header-description"));
});

// Watch for dynamic insertion
const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    $(mutation.addedNodes).each(function () {
      if (
        $(this).is(".boost-sd__header-description") ||
        $(this).find(".boost-sd__header-description").length
      ) {
        setupReadMore($(".boost-sd__header-description"));
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});
